/// <amd-module name="SuiteCommerce.PagePrinter.EmptyState.EmptyState.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.EmptyState.EmptyState.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EmptyStateModel = /** @class */ (function (_super) {
        __extends(EmptyStateModel, _super);
        function EmptyStateModel(options) {
            return _super.call(this, options) || this;
        }
        Object.defineProperty(EmptyStateModel.prototype, "buttonLabel", {
            get: function () {
                return this.get('buttonLabel');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(EmptyStateModel.prototype, "message", {
            get: function () {
                return this.get('message');
            },
            enumerable: true,
            configurable: true
        });
        return EmptyStateModel;
    }(Backbone_1.Model));
    exports.EmptyStateModel = EmptyStateModel;
});
